import { render, staticRenderFns } from "./GradeVerticalNavMenu.vue?vue&type=template&id=db3b6fa8&scoped=true&"
import script from "./GradeVerticalNavMenu.vue?vue&type=script&lang=js&"
export * from "./GradeVerticalNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./GradeVerticalNavMenu.vue?vue&type=style&index=0&id=db3b6fa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3b6fa8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VIcon,VImg,VList,VListItem,VListItemIcon,VListItemTitle,VNavigationDrawer,VSlideXTransition})
